module.exports = __webpack_public_path__ + "static/img/main-view-bg.a8b0755.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/main-view/main-view-bg.png
// module id = Nbql
// module chunks = 1